import { useCallback, useEffect, useState } from 'react'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../../../baseComponents/Modal'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'

interface ModalSkipOperateStockOrderProps extends ModalSkipOperateStockOrderLogicProps {
    setOpenModal: SetEditDeleteModalTy
}

const ModalSkipOperateStockOrder: React.FC<ModalSkipOperateStockOrderProps> = ({ setOpenModal, ...rest }) => {
    const { t } = useTwinTranslation()
    const { stockErrors, handleOnAccept } = useModalSkipOperateStockOrderLogic({ ...rest })
    const renderThis: JSX.Element[] = []
    if (stockErrors) {
        for (const element of stockErrors) {
            const nLine = element.agentError.split('-')[1]
            renderThis.push(<StockLine key={nLine} reference={element.reference} nLine={nLine}/>)
        }
    }
    return (
        <ModalSmallCentered opened={true} setOpened={() => setOpenModal(null)} className='flex_height'>
            <h2 className='mb-20'><TwinTrans transKey={'theFollowingProductsAreOutOfStock'}>No hay stock en los siguientes productos:</TwinTrans></h2>
            {renderThis}
            <span className='my-20'><TwinTrans transKey={'continueTheProcessAnyway'}>¿Quieres continuar con el proceso igualmente?</TwinTrans></span>
            <ButtonsModalSmallCentered confirmText={t('accept', 'Aceptar')} onCancel={() => setOpenModal(null)} setOpened={() => {}} onAccept={handleOnAccept}/>
        </ModalSmallCentered>
    )
}

interface ModalSkipOperateStockOrderLogicProps {
    checkStockURLs: string
    allRowData?: RowData
    finalizeOrder: (url: string, navigateUrl: string, extraProps?: TwinDictionary) => Promise<void>
}

const useModalSkipOperateStockOrderLogic = ({ allRowData, checkStockURLs, finalizeOrder }: ModalSkipOperateStockOrderLogicProps) => {
    const [stockErrors, setStockErrors] = useState<TwinDictionary[] | null>(null)
    const getProductsWithoutStock = useCallback(async () => {
        const result = await twinFetchPostJSON(checkStockURLs, { ...allRowData?.extraProps })
        setStockErrors(result)
    }, [setStockErrors, allRowData, checkStockURLs])

    const handleOnAccept = useCallback(async () => {
        if (finalizeOrder) {
            await finalizeOrder(allRowData?.createUrl, allRowData?.navigateUrl, { ...allRowData?.extraProps, skipCheckOperateStock: true })
        } 
    }, [allRowData, finalizeOrder])

    useEffect(() => {
        getProductsWithoutStock()
    }, [getProductsWithoutStock])

    return { getProductsWithoutStock, stockErrors, handleOnAccept }
}

interface StockLineProps {
    reference: string
    nLine: string
}

const StockLine: React.FC<StockLineProps> = ({ reference, nLine}) => {
    return (
        <div className='w-300 mx-auto'>
            <TwinTrans transKey={'line'}>Línea</TwinTrans>
            <span> {nLine} </span>
            <span> - </span>
            <TwinTrans transKey={'productWithReference'}>Producto con referencia</TwinTrans>
            <span> {reference} </span>
        </div>
    )
}




export default ModalSkipOperateStockOrder